/* tslint:disable */
/* eslint-disable */
export enum MethodAttributes {
  PrivateScope = 'PrivateScope',
  Private = 'Private',
  FamAndAssem = 'FamANDAssem',
  Assembly = 'Assembly',
  Family = 'Family',
  FamOrAssem = 'FamORAssem',
  Public = 'Public',
  MemberAccessMask = 'MemberAccessMask',
  UnmanagedExport = 'UnmanagedExport',
  Static = 'Static',
  Final = 'Final',
  Virtual = 'Virtual',
  HideBySig = 'HideBySig',
  NewSlot = 'NewSlot',
  CheckAccessOnOverride = 'CheckAccessOnOverride',
  Abstract = 'Abstract',
  SpecialName = 'SpecialName',
  RtSpecialName = 'RTSpecialName',
  PinvokeImpl = 'PinvokeImpl',
  HasSecurity = 'HasSecurity',
  RequireSecObject = 'RequireSecObject',
  ReservedMask = 'ReservedMask'
}
